/**
 *
 */ import App from 'app/app.js';
import 'app/directive/LtConfirmDeleteDrawerCtrl.js';

function LtWelcomeDirective() {
  return {
    restrict: 'E',
    scope: {
      onInit: '&',
      onContinue: '&',
      onCancel: '&'
    },
    template:
      '	<div class="welcome-PopUp" align="center" ng-init="welcomeCtrl.init()" lt-drawer="welcomeCtrl.visible" >' +
      '	            <div class="cancelSprite" style=" position:absolute;top:0;right:0 ">' +
      '	                <a id="do-cancel-btn" class="welcome-popUp-Close" ng-click="welcomeCtrl.cancelMethod()" lt-translate="CLOSE" data-id="text_link" ></a>' +
      '	            </div>' +
      '	    <div id="most-popular-cont"  style="border-top-color: white;margin-top: 25px;">' +
      '	        <h5 class="text-center" lt-translate="WELCOME_BACK"><b></b></h5>' +
      '	        <div align="center" class="row">' +
      '	            <div class="col-xs-12">' +
      '	                <h6 class="text-center" lt-translate="CONTENT_FOR_EXISTING_USER"></h6>' +
      '	            </div>' +
      '	        </div>' +
      '	        <div align="center" class="row">' +
      '	            <div class="col-xs-12">' +
      '	                <a id="continue" style="width:50% ; height:50%"  align="center" ng-click="welcomeCtrl.loginCtrlMethod()" class="btn blue" lt-translate="CONTINUE_$COUNTRY" data-id="button" ></a>' +
      '	            </div>' +
      '	        </div>' +
      '	    </div>' +
      '	</div>',
    controller: 'LtWelcomeCtrl',
    controllerAs: 'welcomeCtrl'
  };
}

App.directive('ltWelcome', [LtWelcomeDirective]);
